import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GgwImplementationsService} from '@catmodules/models/ggw-implementations/services/ggw-implementations.service';
import {UIFormModule} from '@catuiform/ui-form.module';
import {FeatureGgwDeviceLandingComponent} from "@catmodules/models/ggw-device/components/feature-ggw-device-landing/feature-ggw-device-landing.component";
import {GgwDevicesService} from "@catmodules/models/ggw-device/services/ggw-devices.service";
import {UIBaseModule} from "@catui/ui-base.module";
import {FeatureGgwDevicesService} from "@catmodules/models/ggw-device/services/feature-ggw-devices.service";
import {FeatureGgwDeviceFormComponent} from "@catmodules/models/ggw-device/components/feature-ggw-device-form/feature-ggw-device-form.component";
import {GgwDeviceParamsModule} from "@catmodules/models/ggw-device-params/ggw-device-params.module";
import { ProjectGgwDeviceFormComponent } from './components/project-ggw-device-form/project-ggw-device-form.component';
import { InputIconPosComponent } from './components/input-icon-pos/input-icon-pos.component';
import { ModifyGgwDeviceComponent } from './components/modify-ggw-device/modify-ggw-device.component';

const publicComponents = [
    FeatureGgwDeviceLandingComponent,
    FeatureGgwDeviceFormComponent,
    ProjectGgwDeviceFormComponent,
    InputIconPosComponent,
    ModifyGgwDeviceComponent
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIBaseModule,
  UIFormModule,
  FormsModule,
  GgwDeviceParamsModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [
    GgwDevicesService,
    FeatureGgwDevicesService
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class GgwDeviceModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-device/ggw-device.module.ts